import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "siga_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const key = (p) => `${p.product_id}::${p.variant || ""}`;

  const addItem = (item) => {
    setItems((prev) => {
      const idx = prev.findIndex((x) => key(x) === key(item));
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + (item.quantity || 1) };
        return next;
      }
      return [...prev, { ...item, quantity: item.quantity || 1 }];
    });
    setOpen(true);
  };

  const removeItem = (k) => setItems((prev) => prev.filter((x) => key(x) !== k));

  const updateQty = (k, qty) =>
    setItems((prev) =>
      prev.map((x) => (key(x) === k ? { ...x, quantity: Math.max(1, qty) } : x))
    );

  const clear = () => setItems([]);

  const totals = useMemo(() => {
    const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
    const shipping = items.length === 0 ? 0 : subtotal >= 999 ? 0 : 79;
    const total = subtotal + shipping;
    const count = items.reduce((s, i) => s + i.quantity, 0);
    return { subtotal, shipping, total, count };
  }, [items]);

  return (
    <CartContext.Provider
      value={{ items, addItem, removeItem, updateQty, clear, totals, open, setOpen, key }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
